export class EBoksTilmelding {
    public id: number;
    public cprNummer: string;
    public cvrNummer: string;
    public pNummer: string;
    public samtykkeTekst: string;
}
